var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events-filters"},[_c('b-row',[_c('b-col',[_vm._v("name")]),_vm._v(" "),_c('b-col',[_vm._v("desde")]),_vm._v(" "),_c('b-col',[_vm._v("hasta")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }